import * as notificationActions from "./notification.actions";

export const notificationFeatureKey = "notificationInfo";

const initialState = {
    loading: false,
    errorMessage: "",
    notificationList: [],
    notificationListTotal: "",
    tipsNotificationList: [],
    tipsNotificationListTotal: ""
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case notificationActions.SEND_NOTIFICATION_TO_ALL_USERS_REQUEST:
            return {
                ...state,
                loading: true
            }

        case notificationActions.SEND_NOTIFICATION_TO_ALL_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                notificationList: [payload.data, ...state.notificationList]
            }

        case notificationActions.SEND_NOTIFICATION_TO_ALL_USERS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: payload
            }

        case notificationActions.GET_ALL_NOTIFICATION_REQUEST:
            return {
                ...state,
                loading: true
            }

        case notificationActions.GET_ALL_NOTIFICATION_SUCCESS:
            console.log('payload', payload)
            return {
                ...state,
                loading: false,
                notificationList: payload.data?.length > 0 ? payload.data[0].results : [],
                notificationListTotal: payload.data?.length > 0 ? payload.data[0].total : 0
            }

        case notificationActions.GET_ALL_NOTIFICATION_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: payload
            }

        case notificationActions.SEND_TIPS_NOTIFICATION_TO_ALL_USERS_REQUEST:
            return {
                ...state,
                loading: true
            }

        case notificationActions.SEND_TIPS_NOTIFICATION_TO_ALL_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                tipsNotificationList: [payload.data, ...state.notificationList]
            }

        case notificationActions.SEND_TIPS_NOTIFICATION_TO_ALL_USERS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: payload
            }

        case notificationActions.GET_ALL_TIPS_NOTIFICATION_REQUEST:
            return {
                ...state,
                loading: true
            }

        case notificationActions.GET_ALL_TIPS_NOTIFICATION_SUCCESS:
            console.log('payload', payload)
            return {
                ...state,
                loading: false,
                tipsNotificationList: payload.data?.length > 0 ? payload.data[0].results : [],
                tipsNotificationListTotal: payload.data?.length > 0 ? payload.data[0].total : 0
            }

        case notificationActions.GET_ALL_TIPS_NOTIFICATION_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: payload
            }

        case notificationActions.SEND_NOTIFICATION_TO_USER_REQUEST:
            return {
                ...state,
                loading: true
            }

        case notificationActions.SEND_NOTIFICATION_TO_USER_SUCCESS:
            return {
                ...state,
                loading: false
            }

        case notificationActions.SEND_NOTIFICATION_TO_USER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: payload
            }

        default: return state;
    }
};